import React from 'react'


import htu1 from '../../../images/htu1.png'
import htu2 from '../../../images/htu2.png'
import htu3 from '../../../images/htu3.png'


const BlogArea = () => {
  return (
    <section className="third-about-bg pt-115 pb-120">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12 col-lg-12">
          <div className="third-section-title text-center mb-5">
            <h2 style={{"fontFamily": "'Oxanium', cursive"}}>How It <span>Works</span></h2>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">

        <div className="col-lg-4 col-md-6 col-sm-9">
          <div className="blog-post home-four-blog-post mb-50">
            <div className="blog-thumb mb-30">
              <img src={htu1} alt="" style={{'width': '30%'}} />
            </div>
            <div className="blog-post-content">
              <h5 style={{'color':'white'}}>Create your own profile</h5>
              {/* <p>Compete with 100 players on a remote island thats winner takes showdown known issue.</p> */}
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6 col-sm-9">
          <div className="blog-post home-four-blog-post mb-50">
            <div className="blog-thumb mb-30">
              <img src={htu2} alt="" style={{'width': '30%'}} />
            </div>
            <div className="blog-post-content">
              <h5 style={{'color':'white'}}>Mint your own community token</h5>
              {/* <p>Compete with 100 players on a remote island thats winner takes showdown known issue.</p> */}
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6 col-sm-9">
          <div className="blog-post home-four-blog-post mb-50">
            <div className="blog-thumb mb-30">
              <img src={htu3} alt="" style={{'width': '15%'}} />
            </div>
            <div className="blog-post-content">
              <h5 style={{'color':'white'}}>Engage and earn with your friends</h5>
              {/* <p>Compete with 100 players on a remote island thats winner takes showdown known issue.</p> */}
            </div>
          </div>
        </div>

        
      </div>
    </div>
  </section>
  )
}

export default BlogArea